import React, { useState, useEffect } from "react";
import { AnnualPricing, LifetimePricing } from "../../utils/config/pricing";
import "./PlanSelect.scss";
import { useSelector } from "react-redux";
import { getActivePlanList } from "../../utils/services/lighthouse";
import { BsInfoCircle } from "react-icons/bs";
import { FaCircleCheck } from "react-icons/fa6";
import { Tooltip } from "react-tooltip";
import { Dialog } from "@mui/material";
import { InformationDialog } from "../../dialogs";
// import { DisclaimerBar } from "../../components";

interface PlanSelectProps {
  setSelectedPlan: any;
  setCurrentScreen: any;
}

const PlanSelect: React.FC<PlanSelectProps> = ({
  setSelectedPlan,
  setCurrentScreen,
}) => {
  const [pricingType, setPricingType] = useState<string>("annual");
  const [pricingPlans, setPricingPlans] = useState<any[]>([]);
  const [activePlanList, setActivePlanList] = useState<any[]>([]);
  const [isInformationDialog, setInformationDialog] = useState<boolean>(false);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      (async () => {
        const response = await getActivePlanList();
        setActivePlanList(response);
      })();
    }

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let componentMounted = true;
    componentMounted &&
      setPricingPlans(
        pricingType === "annual" ? AnnualPricing : LifetimePricing
      );
    return () => {
      componentMounted = false;
    };
  }, [pricingType]);

  const setPlan = async (planDetails: any) => {
    const filteredPlan = activePlanList.filter(
      (item: any) => item?.planName === planDetails.title
    );
    if (filteredPlan?.length > 0)
      planDetails["index"] = filteredPlan[0]?.subscriptionId;
    setSelectedPlan(planDetails);
    setCurrentScreen("PaymentType");
  };

  return (
    <>
      <div className="PlanSelect">
        <div className="PricingSection">
          <div className="PricingSection__switchContainer">
            <p>Annually</p>
            <div
              onClick={() => {
                setPricingType(
                  pricingType === "annual" ? "lifetime" : "annual"
                );
              }}
              className="switchBox ptr"
            >
              <div
                className="switchBox__circle"
                style={
                  pricingType === "lifetime"
                    ? { right: "10px", left: "auto" }
                    : { right: "auto", left: "10px" }
                }
              ></div>
            </div>
            <p>Lifetime</p>
          </div>
          <p
            className="PricingSection__Subtitle"
            style={{ fontSize: "1rem", marginTop: "1rem" }}
          >
            {pricingType === "lifetime" ? (
              <span>
                Hassle free, price-beating lifetime plans. No recurring
                subscription fees, just a one time payment to secure your
                storage for life!

                <p style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={()=>{
                  setInformationDialog(true)
                }}>How long will data be stored on Lighthouse?</p>
              </span>
            ) : (
              <span>
                Easy, convenient and budget friendly plans. Just Pay Annually.
              </span>
            )}
          </p>

          <div className="PricingSection__PriceCardContainer">
            {pricingPlans.map((item, index) => (
              <div className="PriceCard" key={"card" + index}>
                <p className="PriceCard__title">{item?.title}</p>
                <div className="PriceCard__icon">
                  <img src={item?.icon_light} alt="pricecardIcon" />
                </div>
                <p className="PriceCard__price">
                  ${item?.cost}&nbsp;
                  <span> {pricingType === "lifetime" ? "" : "/annum"}</span>
                </p>
                <div className="PriceCard__FeatureContainer">
                  <table>
                    <tbody>
                      {item?.features.map((feature: any, fIndex: number) => (
                        <tr key={`tr${fIndex}`}>
                          <td>
                            <p
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {feature?.title} &nbsp;
                              <BsInfoCircle
                                data-tooltip-id="PlanSelect-tooltip"
                                data-tooltip-content={feature?.tooltip}
                              />
                            </p>
                          </td>
                          <td>
                            <p style={{textAlign:'center'}}>{feature?.value === 'icon' ? <FaCircleCheck/> : feature.value}</p>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {item?.onlyShow ? (
                  <></>
                ) : (
                  <button
                    className="fillBtn__blue"
                    style={{ width: "70%", marginTop: "1rem" }}
                    onClick={() => setPlan(item)}
                  >
                    Buy Now
                  </button>
                )}
              </div>
            ))}
          </div>
       
        </div>
        <Tooltip id="PlanSelect-tooltip" />
      </div>
      <Dialog
        open={isInformationDialog}
        onClose={() => {setInformationDialog(false)}}
      >
        <InformationDialog setInformationDialog={setInformationDialog} title="How long will data be stored on Lighthouse?" information={`
          As we move closer to our mainnet launch, we aim to be transparent about the estimated duration of data storage. Initially, your data might be projected to remain stored for around 25 years. <br> However, as the endowment pool grows over time, aligned with Lighthouse’s economic model, this duration is expected to increase. <br> <br>If the model performs as designed, your files should remain stored for a long period without requiring additional payments as part of lifetime plan. In the unlikely event that the endowment pool depletes its funds, users might need to contribute again to continue storage`} />
      </Dialog>
    </>
  );
};

export default PlanSelect;
